import type { CesiumViewer } from '@aus-platform/cesium';
import type { ImageryLayer } from 'cesium';
import { DrawingTools } from '../drawing-tools/drawing-tools';
import type { IAoiManager } from './aoi-manager-interface';

export class AoiManager implements IAoiManager {
  readonly drawingTools: DrawingTools;
  private imageryLayers = new Set<ImageryLayer>();

  constructor(viewer: CesiumViewer) {
    this.drawingTools = new DrawingTools(viewer);
  }

  addImageryLayer(layer: ImageryLayer) {
    this.imageryLayers.add(layer);
  }

  removeImageryLayer(layer: ImageryLayer) {
    this.imageryLayers.delete(layer);
  }

  setVisibility(visible: boolean) {
    this.drawingTools.setAllFeaturesVisibility(visible);
    this.imageryLayers.forEach((layer) => {
      layer.show = visible;
    });
  }

  resetState() {
    this.drawingTools.resetState();
    this.imageryLayers.forEach((layer) => {
      layer.show = false;
    });
    this.imageryLayers.clear();
  }

  destroy() {
    this.imageryLayers.clear();
    this.drawingTools.destroy();
  }

  get polygonTool() {
    return this.drawingTools.polygonTool;
  }

  get lineTool() {
    return this.drawingTools.lineTool;
  }
}
